import React, { useEffect, useState } from 'react';
import BotonDecada from '../UI/botones/BotonDecada';
import * as Funciones from '../funciones/FuncionesTorneos';
import styles from './SelectorDecadaTorneo.module.css';

const SelectorDecadaTorneo = (props) => {
  const torneos = props.torneos;
  const [decadas, setDecadas] = useState([]);
  const [botonPresionado, setBotonPresionado] = useState(null);
  const onDecadaElegida = props.onDecadaElegida;

  useEffect(() => {
    if (torneos && torneos.length > 0) {
      const decadas = Funciones.DecadasTorneos(torneos);
      setDecadas(decadas);
      if (decadas.length > 0) {
        onDecadaElegida(decadas[decadas.length - 1]);
        setBotonPresionado(decadas[decadas.length - 1]);
      }
    }
  }, [torneos, onDecadaElegida]);

  const onclickBotonDecada = (decada) => {
    props.onDecadaElegida(decada);
    setBotonPresionado(decada);
  };

  return (
    <div className={`${styles.selectorDecadas}`}>
      {decadas.length > 1 && (
        <React.Fragment>
          <div className={`${styles.tituloDecadas}`}>Decada</div>
          <div className={`${styles.botoneraDecadas}`}>
            {decadas.map((decada) => (
              <BotonDecada
                id={decada}
                key={decada}
                decada={decada}
                estilo={`${styles.botonDecada}`}
                presionado={Number(decada) === Number(botonPresionado)}
                onClick={onclickBotonDecada}
              />
            ))}
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default SelectorDecadaTorneo;
